/* Hound Theory theme behaviour: colour mode, breed tabs, size finder, back-in-stock. */
(function () {
  const root = document.documentElement;
  const cfg = window.htConfig || { strings: {} };
  // Shopify's `t` filter HTML-encodes translations (dog's -> dog&#39;s). These strings are set via
  // textContent, so decode them once here.
  (function decodeStrings(o) {
    const ta = document.createElement('textarea');
    const walk = (x) => {
      Object.keys(x || {}).forEach((k) => {
        if (typeof x[k] === 'string' && x[k].includes('&')) { ta.innerHTML = x[k]; x[k] = ta.value; }
        else if (x[k] && typeof x[k] === 'object') walk(x[k]);
      });
    };
    walk(o);
  })(cfg);

  /* ---------- Colour mode ---------- */
  function syncModeButtons() {
    const dark = root.getAttribute('data-ht-mode') === 'dark';
    document.querySelectorAll('[data-ht-mode-toggle]').forEach((btn) => {
      btn.setAttribute('aria-pressed', String(dark));
      btn.setAttribute('aria-label', dark ? cfg.strings.toLight : cfg.strings.toDark);
    });
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ht-mode-toggle]');
    if (!btn) return;
    const next = root.getAttribute('data-ht-mode') === 'dark' ? 'light' : 'dark';
    const apply = () => {
      root.setAttribute('data-ht-mode', next);
      try { localStorage.setItem('ht-mode', next); } catch (err) {}
      syncModeButtons();
    };
    // Text and background must change together: crossfade the whole page when the browser can,
    // otherwise switch in one frame with colour transitions off.
    if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.startViewTransition(apply);
    } else {
      root.classList.add('ht-mode-switching');
      apply();
      requestAnimationFrame(() => requestAnimationFrame(() => root.classList.remove('ht-mode-switching')));
    }
  });
  syncModeButtons();
  // Back/forward restores pages from the bfcache with their old mode; re-read the saved choice.
  function applyStoredMode() {
    let m = null;
    try { m = localStorage.getItem('ht-mode'); } catch (err) {}
    if (m && m !== root.getAttribute('data-ht-mode')) root.setAttribute('data-ht-mode', m);
    syncModeButtons();
  }
  window.addEventListener('pageshow', applyStoredMode);
  window.addEventListener('storage', (e) => { if (e.key === 'ht-mode') applyStoredMode(); });

  /* ---------- Tabs (breed switcher) ---------- */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-ht-tab]');
    if (!tab) return;
    const wrap = tab.closest('[data-ht-tabs]');
    wrap.querySelectorAll('[data-ht-tab]').forEach((t) => { t.setAttribute('aria-selected', String(t === tab)); t.tabIndex = t === tab ? 0 : -1; });
    wrap.querySelectorAll('[data-ht-panel]').forEach((p) => { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
  });
  // ARIA tabs keyboard pattern: one Tab stop for the row, arrows / Home / End move and select
  document.addEventListener('keydown', (e) => {
    const tab = e.target.closest && e.target.closest('[data-ht-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[data-ht-tab]')];
    const k = tabs.indexOf(tab);
    const n = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : (k + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    e.preventDefault();
    tabs[n].focus();
    tabs[n].click();
  });

  /* ---------- Size finder ----------
     Same charts and rules as the Messenger bot's "Size Calc" tool (n8n "HT AI Agent"):
     vest = chest decides; jumpsuit/sweater = back length decides, chest warns;
     coat = closest back length (numbered sizes), spine-to-chest depth warns. */
  function num(v) {
    const n = parseFloat(String(v).replace(',', '.'));
    return Number.isFinite(n) && n > 0 ? n : null;
  }
  const within = (v, r) => v >= r[0] && v <= r[1];
  const lo = (r) => (Array.isArray(r) ? r[0] : r);
  const hi = (r) => (Array.isArray(r) ? r[1] : r);
  const closest = (rows, key, v) =>
    rows.reduce((best, r, i) => {
      // Same as the bot: distance to the range's lower bound, so a gap value rounds up to the bigger size.
      const d = Array.isArray(r[key]) ? (within(v, r[key]) ? 0 : Math.abs(r[key][0] - v)) : Math.abs(r[key] - v);
      return d < best.d ? { i, d } : best;
    }, { i: 0, d: Infinity }).i;
  const fill = (s, o) => Object.keys(o).reduce((acc, k) => acc.split(`{{ ${k} }}`).join(o[k]), s);
  const span = (rows, key) => [lo(rows[0][key]), hi(rows[rows.length - 1][key])];

  // cm / inch: charts and the calculator boxes follow one shared switch (remembered per browser).
  const IN = 2.54;
  let unit = 'cm';
  try { if (localStorage.getItem('ht-unit') === 'in') unit = 'in'; } catch (e) {}
  const fmt1 = (v) => String(Math.round(v * 10) / 10);
  const U = (cm) => (unit === 'in' ? `${fmt1(cm / IN)} inch` : `${fmt1(cm)} cm`);
  function applyUnit(next) {
    const prev = unit;
    unit = next;
    try { localStorage.setItem('ht-unit', unit); } catch (e) {}
    document.querySelectorAll('[data-ht-unit]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.htUnit === unit)));
    document.querySelectorAll('td[data-cm]').forEach((td) => {
      td.textContent = td.dataset.cm.split('|').map((v) => (unit === 'in' ? fmt1(parseFloat(v) / IN) : v)).join('–');
    });
    document.querySelectorAll('[data-ht-fit-form] input[name]').forEach((i) => {
      i.placeholder = unit === 'in' ? 'inch' : 'cm';
      const v = parseFloat(String(i.value).replace(',', '.'));
      if (prev === unit || !Number.isFinite(v)) return;
      // keep the exact cm the shopper typed, so cm -> inch -> cm gives the same number back
      if (prev === 'cm') i.dataset.cm = String(v);
      const cm = i.dataset.cm != null && prev === 'in' && Math.abs(parseFloat(i.dataset.cm) / IN - v) < 0.06 ? parseFloat(i.dataset.cm) : (prev === 'cm' ? v : v * IN);
      i.value = unit === 'in' ? fmt1(cm / IN) : fmt1(cm);
    });
    document.querySelectorAll('[data-ht-fit-form]').forEach((form) => form.dispatchEvent(new Event('input')));
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-ht-unit]');
    if (b && b.dataset.htUnit !== unit) applyUnit(b.dataset.htUnit);
  });
  if (unit === 'in') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => applyUnit('in'));
    else setTimeout(() => applyUnit('in'));
  }

  /* Every check returns { idx, status, notes, off }:
     status 'perfect' = every measurement sits inside the chosen size;
     'close' = a size is suggested but something does not line up;
     'check' = the numbers look wrong (outside the chart or not sighthound proportions).
     off = input names to highlight. The size itself follows the bot's rule. */
  function lettered(rows, m, t, primary, secondary, ratio) {
    // primary decides the size (bot rule); secondary confirms or warns.
    const r = { idx: null, status: 'perfect', notes: [], off: [] };
    const label = { length: t.length, chest: t.chest };
    const P = primary === 'length' ? 'back' : 'chest';
    const S = secondary === 'length' ? 'back' : 'chest';
    const pSpan = span(rows, P);
    const sSpan = span(rows, S);
    if (m[primary] < pSpan[0] - 2 || m[primary] > pSpan[1] + 2) {
      r.status = 'check'; r.off.push(primary);
      r.notes.push(fill(t.out_range, { what: label[primary], min: U(pSpan[0]), max: U(pSpan[1]) }));
      return r;
    }
    r.idx = closest(rows, P, m[primary]);
    if (!within(m[primary], rows[r.idx][P])) { r.status = 'close'; r.notes.push(t.gap); }
    if (!m[secondary]) {
      if (r.status === 'perfect') r.status = 'close';
      r.notes.push(fill(t.add, { what: label[secondary].toLowerCase() }));
      return r;
    }
    if (m[secondary] < sSpan[0] - 2 || m[secondary] > sSpan[1] + 2) {
      r.status = 'check'; r.off.push(secondary);
      r.notes.push(fill(t.out_range, { what: label[secondary], min: U(sSpan[0]), max: U(sSpan[1]) }));
      return r;
    }
    const q = m.chest / m.length;
    if (m.chest && m.length && (q < ratio[0] || q > ratio[1])) {
      r.status = 'check'; r.off.push('length', 'chest'); r.notes.push(t.odd);
      return r;
    }
    // Chart edges are shared (40 = top of 2XS and bottom of XS), so only flag a real mismatch.
    const sIdx = within(m[secondary], rows[r.idx][S]) ? r.idx : closest(rows, S, m[secondary]);
    // Vests are cut shorter than the dog's back: with the (doubled) chest deciding, the length column naturally runs
    // ~2 sizes ahead, so for vests only a bigger gap is worth a note.
    const vestOk = secondary === 'length' && primary === 'chest' && Math.abs(sIdx - r.idx) <= 2;
    if (sIdx !== r.idx && !vestOk) {
      r.status = 'close'; r.off.push(secondary);
      r.notes.push(fill(t.between, { a: rows[r.idx].size, b: rows[sIdx].size, first: label[primary].toLowerCase(), second: label[secondary].toLowerCase() }));
      if (secondary === 'chest') r.notes.push(sIdx > r.idx ? fill(t.tight, { max: U(hi(rows[r.idx].chest)) }) : t.loose);
      else r.notes.push(sIdx > r.idx ? t.vest_short : t.vest_long);
    }
    // Neck (C) is optional: it only confirms or warns, it never changes the size.
    const nk = rows[r.idx].neck;
    if (m.neck && nk) {
      const nSpan = span(rows, 'neck');
      if (m.neck < nSpan[0] - 4 || m.neck > nSpan[1] + 4) {
        r.status = 'check'; r.off.push('neck');
        r.notes.push(fill(t.out_range, { what: t.neck, min: U(nSpan[0]), max: U(nSpan[1]) }));
      } else if (m.neck > nk[1]) {
        if (r.status === 'perfect') r.status = 'close';
        r.off.push('neck'); r.notes.push(fill(t.neck_tight, { max: U(nk[1]) }));
      } else if (m.neck < nk[0]) {
        if (r.status === 'perfect') r.status = 'close';
        r.off.push('neck'); r.notes.push(fill(t.neck_loose, { min: U(nk[0]) }));
      }
    }
    return r;
  }

  const FIT = {
    // Jumpsuits & sweaters: back length decides, chest confirms. Chart chest/length is ~1.35.
    knit: (rows, m, t) => (m.length ? lettered(rows, m, t, 'length', 'chest', [1.0, 1.8]) : null),
    // Vests: chest decides, length confirms. Full chest / back length on the vest chart is ~1.6 (the chart is stored doubled).
    vest: (rows, m, t) => (m.chest ? lettered(rows, m, t, 'chest', 'length', [1.1, 2.3]) : null),
    // Coats: closest garment length decides; spine-to-chest depth must fit under the coat.
    coat(rows, m, t) {
      if (!m.length) return null;
      const r = { idx: null, status: 'perfect', notes: [], off: [] };
      const L = span(rows, 'back');
      if (m.length < L[0] - 3 || m.length > L[1] + 3) {
        r.status = 'check'; r.off.push('length');
        r.notes.push(fill(t.out_range, { what: t.length, min: U(L[0]), max: U(L[1]) }));
        return r;
      }
      r.idx = closest(rows, 'back', m.length);
      const row = rows[r.idx];
      if (Math.abs(row.back - m.length) > 1.5) {
        const other = m.length > row.back ? rows[r.idx + 1] : rows[r.idx - 1];
        r.status = 'close';
        r.notes.push(other ? fill(t.coat_between, { a: row.size, b: other.size, len: U(row.back) }) : fill(t.coat_len, { len: U(row.back) }));
      }
      if (!m.spine) {
        if (r.status === 'perfect') r.status = 'close';
        r.notes.push(fill(t.add, { what: t.spine.toLowerCase() }));
        return r;
      }
      if (m.spine > 40) { r.status = 'check'; r.off.push('spine'); r.notes.push(t.depth_circ); return r; }
      const q = m.spine / m.length;
      if (q < 0.3 || q > 0.85) { r.status = 'check'; r.off.push('length', 'spine'); r.notes.push(t.odd); return r; }
      if (m.spine > row.depth) {
        r.status = 'close'; r.off.push('spine');
        r.notes.push(fill(t.deep, { depth: U(row.depth) }));
      }
      return r;
    },
  };

  function initFit(box) {
    if (box.dataset.htReady) return;
    box.dataset.htReady = '1';
    const data = JSON.parse(box.querySelector('[data-ht-fit-data]').textContent);
    const form = box.querySelector('[data-ht-fit-form]');
    const out = box.querySelector('[data-ht-fit-result]');
    const chartSelect = box.querySelectorAll('[data-ht-chart]');
    let chartKey = box.dataset.chart || 'knit';

    function showChart() {
      box.dataset.chart = chartKey;
      box.querySelectorAll('[data-ht-chart-table]').forEach((tb) => { tb.hidden = tb.dataset.htChartTable !== chartKey; });
      box.querySelectorAll('[data-ht-chart-fields]').forEach((f) => { f.hidden = !f.dataset.htChartFields.split(' ').includes(chartKey); });
      chartSelect.forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.htChart === chartKey)));
    }

    function run() {
      const m = {};
      form.querySelectorAll('input[name]').forEach((i) => {
        i.classList.remove('is-off');
        if (!i.closest('[hidden]')) { const v = num(i.value); m[i.name] = v && unit === 'in' ? v * IN : v; }
      });
      const rows = data.charts[chartKey];
      const t = data.t;
      const res = FIT[chartKey](rows, m, t);
      box.querySelectorAll('[data-ht-chart-table] tr.is-match').forEach((tr) => tr.classList.remove('is-match'));
      out.dataset.status = res ? res.status : '';
      if (!res) { out.innerHTML = `<span class="ht-fit__note">${t['empty_' + chartKey]}</span>`; return; }
      res.off.forEach((n) => { const i = form.querySelector(`input[name="${n}"]`); if (i) i.classList.add('is-off'); });
      const badge = `<span class="ht-fit__status">${t['status_' + res.status]}</span>`;
      const notes = res.notes.length ? res.notes.join(' ') : t.good;
      if (res.idx === null || res.status === 'check') {
        // A suspicious number must not produce a confident-looking size. The next real size counts as new again
        // (the letter changes from "?"), so it flips in and gets its tape drawn.
        delete box.dataset.lastSize;
        out.innerHTML = `<span class="ht-fit__size is-q">?</span><span class="ht-fit__body">${badge}<span class="ht-fit__note">${notes}</span><span class="ht-fit__help-mail">${t.help_html || ''}</span></span>`;
        return;
      }
      const row = rows[res.idx];
      const fresh = box.dataset.lastSize !== `${chartKey}:${row.size}`;
      box.dataset.lastSize = `${chartKey}:${row.size}`;
      const body = `<span class="ht-fit__body">${badge}<span class="ht-fit__note">${notes}</span></span>`;
      // same size as before: keep its element so a running flip-in / tape draw isn't cut off by the next keystroke
      const keep = !fresh && out.querySelector(':scope > .ht-fit__size:not(.is-q)');
      if (keep && keep.textContent === String(row.size) && out.querySelector(':scope > .ht-fit__body')) out.querySelector(':scope > .ht-fit__body').outerHTML = body;
      else out.innerHTML = `<span class="ht-fit__size${fresh ? ' is-new' : ''}">${row.size}</span>${body}`;
      const tr = box.querySelector(`[data-ht-chart-table="${chartKey}"] tr[data-row="${res.idx}"]`);
      if (tr) { tr.classList.add('is-match'); tr.classList.toggle('is-new', fresh); }
      box.dispatchEvent(new CustomEvent('ht:fit', { bubbles: true, detail: { size: row.size } }));
    }

    form.addEventListener('input', (e) => { if (e.isTrusted && e.target.dataset) delete e.target.dataset.cm; run(); });
    chartSelect.forEach((c) => c.addEventListener('click', () => { chartKey = c.dataset.htChart; showChart(); run(); }));
    // Sighthounds | Dachshund. The dachshund side has no charts yet, so it only shows the slider.
    box.querySelectorAll('[data-ht-group]').forEach((b) =>
      b.addEventListener('click', () => {
        box.dataset.group = b.dataset.htGroup;
        box.querySelectorAll('[data-ht-group]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      })
    );
    showChart();
  }

  document.addEventListener('click', (e) => {
    const zoom = e.target.closest('[data-ht-zoom]');
    if (zoom) { zoom.classList.toggle('is-zoomed'); return; }
    const open = e.target.closest('[data-ht-fit-open]');
    if (open) {
      const dlg = document.getElementById(open.getAttribute('aria-controls'));
      if (dlg) {
        initFit(dlg.querySelector('[data-ht-fit]'));
        // One sticky top bar for the size guide button and the round close, so both stay on screen.
        if (!dlg.querySelector('.ht-dialog__bar')) {
          const bar = document.createElement('div');
          bar.className = 'ht-dialog__bar';
          const guide = dlg.querySelector('.ht-fit__guide');
          if (guide) bar.append(guide);
          const x = dlg.querySelector('[data-ht-dialog-close]');
          if (x) bar.append(x);
          dlg.prepend(bar);
        }
        dlg.showModal();
      }
      return;
    }
    if (e.target.closest('[data-ht-dialog-close]') || e.target.matches('dialog.ht-dialog')) {
      const dlg = e.target.closest('dialog');
      if (!dlg || dlg.classList.contains('is-closing')) return;
      // the X turns, then the window shrinks away (~0.2 s) before it really closes
      dlg.classList.add('is-closing');
      setTimeout(() => { dlg.close(); dlg.classList.remove('is-closing'); }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 200);
    }
  });
  document.querySelectorAll('[data-ht-fit]:not(dialog [data-ht-fit])').forEach(initFit);

  // Picking a size in the finder preselects it on the product form; that size pill glows once when the finder
  // window closes (the shopper sees where the size went). Dawn re-renders the picker, so it is looked up again then.
  let glowSize = null;
  const sizeInput = (size) => {
    const picker = document.querySelector('variant-selects');
    return picker && Array.from(picker.querySelectorAll('input[type="radio"]')).find((i) => i.value === String(size));
  };
  document.addEventListener('ht:fit', (e) => {
    const input = sizeInput(e.detail.size);
    if (!input) return;
    if (!input.checked) input.click();
    glowSize = String(e.detail.size);
  });
  function glowPill() {
    const size = glowSize;
    glowSize = null;
    if (!size || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const input = sizeInput(size);
    const label = input && input.id && document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
    if (!label) return;
    label.classList.remove('m-glow-once'); void label.offsetWidth; label.classList.add('m-glow-once');
    label.addEventListener('animationend', () => label.classList.remove('m-glow-once'), { once: true });
  }
  document.addEventListener('close', (e) => { if (e.target.matches && e.target.matches('dialog.ht-dialog') && glowSize) setTimeout(glowPill, 150); }, true);

  /* ---------- Complete the look ----------
     Pairs come from Search & Discovery (complementary products). The paired piece's size is
     pre-picked from the current selection: letter sizes and coat numbers share one chart
     (1 = 2XS ... 10 = 5XL), so M on a jumpsuit suggests 4 on a coat. */
  const esc = (v) => String(v == null ? '' : v).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const LETTERS = ['2XS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
  const isSizeName = (n) => /^(size|méret|meret)$/i.test(String(n).trim());
  function sizeEquivalent(current, values) {
    if (!current) return null;
    if (values.includes(current)) return current;
    const li = LETTERS.indexOf(current);
    if (li > -1 && values.includes(String(li + 1))) return String(li + 1);
    const n = parseInt(current, 10);
    if (n >= 1 && n <= 10 && values.includes(LETTERS[n - 1])) return LETTERS[n - 1];
    return null;
  }
  function formatMoney(cents, fmt) {
    const value = cents / 100;
    const group = (x, sep) => x.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    const noDec = Math.round(value).toString();
    const withDec = value.toFixed(2);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => ({
      amount: group(withDec.split('.')[0], ',') + '.' + withDec.split('.')[1],
      amount_no_decimals: group(noDec, ','),
      amount_with_comma_separator: group(withDec.split('.')[0], '.') + ',' + withDec.split('.')[1],
      amount_no_decimals_with_comma_separator: group(noDec, '.'),
      amount_with_space_separator: group(withDec.split('.')[0], ' ') + ',' + withDec.split('.')[1],
      amount_no_decimals_with_space_separator: group(noDec, ' '),
      amount_with_apostrophe_separator: group(withDec.split('.')[0], "'") + '.' + withDec.split('.')[1],
    }[key] || noDec));
  }
  // Current product selection. The static family preview provides window.htPreview instead of Dawn's form.
  function currentSelection() {
    if (window.htPreview) return window.htPreview.current();
    const form = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    const values = Array.from(document.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select')).map((el) => el.value);
    return { id: form && form.value, values };
  }

  function initComplete(box) {
    const list = box.querySelector('[data-ht-complete-list]');
    const t = JSON.parse(box.querySelector('[data-ht-complete-strings]').textContent);
    const money = (box.dataset.money || '{{amount_no_decimals}} Ft').replace(/<[^>]*>/g, '').trim();
    let products = [];

    function currentSize() {
      const sel = currentSelection();
      return sel.values.find((v) => LETTERS.includes(v) || /^\d{1,2}$/.test(v)) || null;
    }
    function pickVariant(p, optionValues) {
      return p.variants.find((v) => v.options.every((o, i) => o === optionValues[i]));
    }
    function render() {
      const size = currentSize();
      list.innerHTML = products.map((p, pi) => {
        // Pick the size first (only if some colour is in stock in it), then an in-stock colour for that size.
        const sizeIdx = p.options.findIndex(isSizeName);
        let sizePick = null;
        if (sizeIdx > -1) {
          const sizes = [...new Set(p.variants.map((v) => v.options[sizeIdx]))];
          const eq = sizeEquivalent(size, sizes);
          if (eq && p.variants.some((v) => v.available && v.options[sizeIdx] === eq)) sizePick = eq;
        }
        const selects = p.options.map((name, oi) => {
          const values = [...new Set(p.variants.map((v) => v.options[oi]))];
          let chosen = oi === sizeIdx ? sizePick : null;
          if (oi !== sizeIdx) {
            const firstAvail = p.variants.find((v) => v.available && (sizePick === null || v.options[sizeIdx] === sizePick));
            chosen = firstAvail ? firstAvail.options[oi] : null;
          }
          const inStock = (val) => p.variants.some((v) => v.available && v.options[oi] === val);
          const opts = values.map((v) => `<option value="${esc(v)}"${v === chosen ? ' selected' : ''}${inStock(v) ? '' : ' disabled'}>${esc(v)}${inStock(v) ? '' : ` (${esc(t.sold_out)})`}</option>`).join('');
          const hint = oi === sizeIdx && chosen ? `<small class="ht-complete__hint">${t.size_hint}</small>` : '';
          return `<label class="ht-complete__opt"><span>${esc(name)}</span><select data-oi="${oi}"><option value="">${esc(t.choose)}</option>${opts}</select>${hint}</label>`;
        }).join('');
        const alt = (p.media && p.media[0] && p.media[0].alt) || p.title;
        const img = p.featured_image ? `<img src="${esc(p.featured_image)}${p.featured_image.includes('?') ? '&amp;' : '?'}width=240" alt="${esc(alt)}" loading="lazy" width="120" height="120">` : '';
        return `<div class="ht-complete__item" data-pi="${pi}">
          <input type="checkbox" class="ht-complete__check" checked aria-label="${esc(p.title)}">
          <a href="${esc(p.url)}" class="ht-complete__img">${img}</a>
          <div class="ht-complete__info"><a href="${esc(p.url)}" class="ht-complete__name">${esc(p.title)}</a>
            <span class="ht-complete__price">${esc(formatMoney(p.price, money))}</span>
            <div class="ht-complete__opts">${selects}</div></div></div>`;
      }).join('') + `<p class="ht-complete__error" data-ht-complete-error hidden>${t.error}</p>
        <button type="button" class="button ht-complete__add" data-ht-complete-add>${products.length > 1 ? t.add_all : t.add_both}</button>`;
    }

    async function addAll(btn) {
      const sel = currentSelection();
      const items = [{ id: Number(sel.id), quantity: 1 }];
      let missing = false;
      list.querySelectorAll('.ht-complete__item').forEach((row) => {
        if (!row.querySelector('.ht-complete__check').checked) return;
        const p = products[row.dataset.pi];
        const values = Array.from(row.querySelectorAll('select')).map((s) => s.value);
        const v = values.every(Boolean) && pickVariant(p, values);
        if (!v || !v.available) { missing = true; row.classList.add('is-missing'); } else { row.classList.remove('is-missing'); items.push({ id: v.id, quantity: 1 }); }
      });
      box.querySelector('[data-ht-complete-error]').hidden = !missing;
      if (missing || !sel.id) return;
      if (window.htPreview) { window.htPreview.add(items, products); return; }
      const label = btn.textContent;
      if (window.htFlyToBag) window.htFlyToBag(btn, items.length);
      btn.textContent = t.adding; btn.disabled = true;
      try {
        const drawer = document.querySelector('cart-drawer');
        const body = { items };
        if (drawer) { body.sections = drawer.getSectionsToRender().map((s) => s.id); body.sections_url = window.location.pathname; }
        const res = await fetch(`${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || 'add failed');
        // like Dawn's product-form: an empty drawer must drop its empty state first, or the new lines stay hidden
        if (drawer) { drawer.classList.remove('is-empty'); data.id = items[0].id; drawer.renderContents(data); }
        else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      } catch (err) {
        if (window.htFlyCancel) window.htFlyCancel();   // the paw doesn't land on a failed add
        box.querySelector('[data-ht-complete-error]').hidden = false;
        box.querySelector('[data-ht-complete-error]').textContent = err.message;
      } finally {
        btn.textContent = label; btn.disabled = false;
      }
    }

    box.addEventListener('click', (e) => { const b = e.target.closest('[data-ht-complete-add]'); if (b) addAll(b); });
    const getJson = (url) => fetch(url).then((r) => (r.ok ? r.json() : { products: [] }));
    // product type without case/accents ("Kabát" = "kabat"), so a coat never suggests another coat
    const typeKey = (t) => (t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    const ownType = typeKey(box.dataset.productType);
    const helper = (p) => /marker|gift card|ajandekkartya/.test(typeKey(p.type || p.product_type)) || /^atvetel-csomagponton/.test(p.handle || '');   // MPL pickup marker etc.
    const otherType = (p) => p.available && !helper(p) && String(p.id) !== box.dataset.productId && typeKey(p.type) !== ownType;
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    getJson(box.dataset.url).then((data) => {
      const paired = (data.products || []).filter((p) => p.available);
      if (paired.length || !box.dataset.relatedUrl) return paired;
      // No hand-picked pairs yet: related products of a different type (a coat suggests a sweater, not another coat).
      return getJson(box.dataset.relatedUrl).then((rel) => (rel.products || []).filter(otherType).slice(0, 2));
    }).then((picked) => {
      if (picked && picked.length) return picked;
      // Shopify's related list can come back empty (per language, while it recalculates): pick from the catalogue
      // ourselves, one product per other type, so the block never disappears.
      return getJson(`${root}collections/all/products.json?limit=50`).then((all) => {
        const seen = new Set();
        const handles = (all.products || []).filter((p) => {
          const k = typeKey(p.product_type);
          if (!k || k === ownType || seen.has(k) || helper(p) || String(p.id) === box.dataset.productId) return false;
          if (!(p.variants || []).some((v) => v.available)) return false;
          seen.add(k); return true;
        }).slice(0, 2).map((p) => p.handle);
        return Promise.all(handles.map((h) => fetch(`${root}products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)))
          .then((ps) => ps.filter(Boolean));
      });
    }).then((list) => {
      // The related feed lists options as objects ({ name, values }); the code below expects names.
      products = (list || []).map((p) => ({ ...p, options: (p.options || []).map((o) => (typeof o === 'string' ? o : o.name)) }));
      if (!products.length) return;
      render();
      box.hidden = false;
    }).catch(() => {});
    // Re-match sizes when the shopper changes the main product's size.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => { if (products.length) render(); });
    }
  }
  document.querySelectorAll('[data-ht-complete]').forEach(initComplete);

  /* ---------- Bot check: self-hosted proof of work ----------
     The forms server signs a small SHA-256 puzzle; the browser solves it in the background while the
     visitor types (usually well under a second). No third party, no cookies, nothing to click.
     If it can't finish, the form is still sent: the server then confirms new emails by email. */
  const powBase = (() => { try { return new URL((cfg.club && cfg.club.endpoint) || '').origin; } catch (e) { return ''; } })();
  const hex = (buf) => Array.from(new Uint8Array(buf), (b) => b.toString(16).padStart(2, '0')).join('');
  async function solveChallenge() {
    if (!powBase || !(window.crypto && crypto.subtle)) return null;
    const res = await fetch(`${powBase}/api/club/challenge`, { cache: 'no-store' });
    const c = await res.json();
    const enc = new TextEncoder();
    for (let start = 0; start <= c.maxnumber; start += 500) {
      const batch = [];
      for (let n = start; n < start + 500 && n <= c.maxnumber; n += 1) {
        batch.push(crypto.subtle.digest('SHA-256', enc.encode(c.salt + n)).then((h) => (hex(h) === c.challenge ? n : -1)));
      }
      const hit = (await Promise.all(batch)).find((n) => n >= 0);
      if (hit !== undefined) return { salt: c.salt, number: hit, challenge: c.challenge, signature: c.signature };
    }
    return null;
  }
  function startProof(form) {
    if (!form || form.htProof) return;
    form.htProof = solveChallenge().catch(() => null);
  }
  async function takeProof(form) {
    startProof(form);
    const proof = await Promise.race([form.htProof, new Promise((r) => setTimeout(() => r(null), 10000))]);
    form.htProof = null;                               // single use: the next submit gets a fresh puzzle
    return proof;
  }
  async function postJSON(url, body) {
    // The static family preview has no backend: 'preview' endpoints are simulated in proto.js.
    if (url === 'preview' && window.htPreviewApi) return window.htPreviewApi(body);
    const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    let data = {};
    try { data = await res.json(); } catch (e) {}
    return { status: res.status, data };
  }

  /* ---------- Back-in-stock ---------- */
  function setRestock(variant) {
    document.querySelectorAll('[data-ht-restock]').forEach((box) => {
      if (!variant) return;
      box.hidden = variant.available;
      box.dataset.variant = variant.id;
      box.dataset.variantTitle = variant.title;
      const label = box.querySelector('[data-ht-restock-label]');
      if (label) label.textContent = variant.title;
      box.querySelector('[data-ht-restock-ok]').hidden = true;
      box.querySelector('form').hidden = false;
    });
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (evt) => setRestock(evt.data && evt.data.variant));
  }
  document.addEventListener('focusin', (e) => {
    const form = e.target.closest('[data-ht-restock] form, [data-ht-club-form]');
    if (form) startProof(form);
  });
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-ht-restock] form');
    if (!form) return;
    e.preventDefault();
    const box = form.closest('[data-ht-restock]');
    const btn = form.querySelector('button[type="submit"]');
    const err = box.querySelector('[data-ht-restock-error]');
    btn.disabled = true;
    err.hidden = true;
    try {
      const pow = await takeProof(form);
      const { status, data } = await postJSON((cfg.restock && cfg.restock.endpoint) || 'preview', {
        email: form.email.value, variant_id: box.dataset.variant, variant_title: box.dataset.variantTitle,
        product_title: box.dataset.product, locale: cfg.locale, website: form.website.value, pow,
      });
      if (status !== 200 || !data.ok) throw new Error(data.error || 'generic');
      form.hidden = true;
      box.querySelector('[data-ht-restock-ok]').hidden = false;
    } catch (ex) {
      err.hidden = false;
    } finally {
      btn.disabled = false;
    }
  });

  /* ---------- Birthday Club signup ---------- */
  const club = cfg.club || {};
  const CLUB_JOINED = 'ht-club-joined';
  const CLUB_DISMISSED = 'ht-club-dismissed-until';

  function clubDogs(form) {
    return Array.from(form.querySelectorAll('[data-ht-club-dog]')).map((f) => ({
      name: f.querySelector('[name="dog_name"]').value.trim(),
      month: f.querySelector('[name="dog_month"]').value,
      day: f.querySelector('[name="dog_day"]').value,
      year: f.querySelector('[name="dog_year"]').value.trim(),
    }));
  }
  function validDog(d) {
    if (!d.name || !d.month || !d.day) return false;
    const y = d.year ? Number(d.year) : 2024;
    const now = new Date().getFullYear();
    if (d.year && (!/^\d{4}$/.test(d.year) || y > now || y < now - 25)) return false;
    const dt = new Date(y, d.month - 1, d.day);
    return dt.getMonth() === d.month - 1;
  }
  function showClubSuccess(box, data) {
    box.querySelector('[data-ht-club-step="form"]').hidden = true;
    const done = box.querySelector('[data-ht-club-step="done"]');
    done.hidden = false;
    const codeBox = box.querySelector('.ht-club__code');
    const apply = box.querySelector('[data-ht-club-apply]');
    const sent = box.querySelector('.ht-club__sent');
    if (data.status === 'check_email') {
      // Known email: nothing is revealed here; the mailbox owner confirms (and gets the code) by email.
      box.querySelector('[data-ht-club-hello]').textContent = club.checkTitle;
      box.querySelector('[data-ht-club-valid]').textContent = club.checkText;
      codeBox.hidden = true; apply.hidden = true; sent.hidden = true;
    } else if (data.status === 'saved') {
      // Invitation: dogs saved, no new code (past subscribers already had their welcome code).
      box.querySelector('[data-ht-club-hello]').textContent = club.savedTitle;
      box.querySelector('[data-ht-club-valid]').textContent = club.savedText;
      codeBox.hidden = true; apply.hidden = true; sent.hidden = true;
      setTimeout(() => window.htPawBurst && window.htPawBurst(box.querySelector('[data-ht-club-hello]')), 350);
    } else {
      setTimeout(() => window.htPawBurst && window.htPawBurst(codeBox), 450);
      box.querySelector('[data-ht-club-hello]').textContent = club.hello.replace('{dog}', data.dog);
      box.querySelector('[data-ht-club-code]').textContent = data.code;
      box.querySelector('[data-ht-club-valid]').textContent = data.expires ? club.valid.replace('{date}', data.expires) : '';
      apply.href = data.apply_url;
      codeBox.hidden = false; apply.hidden = false; sent.hidden = false;
    }
    try { localStorage.setItem(CLUB_JOINED, '1'); } catch (e) {}
  }

  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-ht-club-add]');
    if (add) {
      const wrap = add.closest('[data-ht-club]').querySelector('[data-ht-club-dogs]');
      const dogs = wrap.querySelectorAll('[data-ht-club-dog]');
      if (dogs.length >= 3) return;
      const clone = dogs[0].cloneNode(true);
      clone.querySelectorAll('input, select').forEach((i) => { i.value = ''; });
      clone.querySelector('[data-ht-club-remove]').hidden = false;
      wrap.appendChild(clone);
      add.hidden = wrap.querySelectorAll('[data-ht-club-dog]').length >= 3;
      clone.querySelector('input').focus();
      return;
    }
    const rm = e.target.closest('[data-ht-club-remove]');
    if (rm) {
      const box = rm.closest('[data-ht-club]');
      rm.closest('[data-ht-club-dog]').remove();
      box.querySelector('[data-ht-club-add]').hidden = false;
      return;
    }
    const copy = e.target.closest('[data-ht-club-copy]');
    if (copy) {
      const code = copy.closest('[data-ht-club]').querySelector('[data-ht-club-code]').textContent;
      (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(() => {
        const label = copy.textContent;
        copy.textContent = `✓ ${club.copied}`;
        copy.classList.add('is-done');
        setTimeout(() => { copy.textContent = label; copy.classList.remove('is-done'); }, 1800);
      }).catch(() => {});
    }
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-ht-club-form]');
    if (!form) return;
    e.preventDefault();
    const box = form.closest('[data-ht-club]');
    const err = box.querySelector('[data-ht-club-error]');
    const btn = form.querySelector('.ht-club__submit');
    const fail = (key) => { err.textContent = (club.errors || {})[key] || club.errors.generic; err.hidden = false; };
    err.hidden = true;
    const invite = form.dataset.invite || '';
    const email = form.email.value.trim();
    const dogs = clubDogs(form);
    if (!invite && !/^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(email)) return fail('email');
    if (!dogs.length || !dogs.every(validDog)) return fail('dog');
    if (!invite && !form.consent.checked) return fail('consent');
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = club.sending;
    try {
      let res;
      if (invite) {
        // invitation link: the signed token already says who this is, so only the dogs are sent
        const lang = (form.querySelector('[name="mail_lang"]:checked') || {}).value;
        res = await postJSON(String(club.endpoint || '').replace(/\/subscribe$/, '/invite/save'), { t: invite, dogs, lang });
      } else {
        const pow = await takeProof(form);
        res = await postJSON(club.endpoint || 'preview', {
          email, dogs, consent: true, locale: cfg.locale, website: form.website.value, pow,
        });
      }
      const { status, data } = res;
      if (status === 429) return fail('rate');
      if (invite && data && data.error === 'expired') { leaveInvite(form); return fail('expired'); }
      if (status !== 200 || !data.ok) return fail(['email', 'dog', 'consent', 'bot'].includes(data.error) ? data.error : 'generic');
      if (data.status !== 'check_email' && data.status !== 'saved' && !data.code) return fail('generic');
      showClubSuccess(box, data);
      const slide = box.closest('[data-ht-slidein]');
      if (slide) slide.classList.add('is-done');
    } catch (ex) {
      fail('generic');
    } finally {
      btn.disabled = false;
      btn.textContent = label;
    }
  });

  /* ---------- Birthday Club slide-in: once, late, never blocking ---------- */
  (function slideIn() {
    const el = document.querySelector('[data-ht-slidein]');
    if (!el) return;
    const invited = new URLSearchParams(location.search).has('club_invite'); // opened by clubInvite() below
    let joined = false, until = 0, views = 0;
    try {
      joined = localStorage.getItem(CLUB_JOINED) === '1';
      until = Number(localStorage.getItem(CLUB_DISMISSED) || 0);
      views = Number(sessionStorage.getItem('ht-pageviews') || 0) + 1;
      sessionStorage.setItem('ht-pageviews', String(views));
    } catch (e) {}
    // Starts as a small teaser; the form only opens when the visitor asks for it.
    el.querySelector('[data-ht-slidein-join]').addEventListener('click', () => {
      // grow from the teaser to the full form (like the home card) instead of jumping in one frame; it is pinned to
      // the bottom, so it grows upwards. The form fades in on top (ht.css).
      const from = el.offsetHeight;
      el.classList.add('is-expanded');
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const to = el.offsetHeight;
        el.style.overflow = 'hidden';
        el.animate([{ height: `${from}px` }, { height: `${to}px` }], { duration: 480, easing: 'cubic-bezier(.2,.8,.2,1)' })
          .onfinish = () => { el.style.overflow = ''; };
      }
      const email = el.querySelector('[name="email"]');
      if (email) email.focus({ preventScroll: true });
    });
    el.querySelector('[data-ht-slidein-close]').addEventListener('click', () => {
      el.classList.remove('is-open');
      setTimeout(() => { el.hidden = true; }, 350);
      if (!el.classList.contains('is-done')) {
        try { localStorage.setItem(CLUB_DISMISSED, String(Date.now() + 30 * 24 * 3600 * 1000)); } catch (e) {}
      }
    });
    if (invited || joined || Date.now() < until) return;
    // On the homepage the club card is also inline; the slide-in waits while that card is on screen.
    const inlineCard = document.querySelector('#birthday-club');
    let shown = false;
    const earliest = Date.now() + (club.delaySeconds || 10) * 1000;
    function show() {
      if (shown || Date.now() < earliest) return;
      if (inlineCard && inlineCard.getBoundingClientRect().top < window.innerHeight) return; // the inline card is on screen
      shown = true;
      el.hidden = false;
      requestAnimationFrame(() => el.classList.add('is-open'));
      window.removeEventListener('scroll', onScroll);
      countdown();
    }
    // The teaser leaves by itself after 10 s (gold line shows the time; paused while touched/hovered). Opening the
    // form or typing stops the timer for good. A timed-out card counts as unanswered: after two of those it rests
    // for 30 days like a closed one. The club stays reachable from the menu and the home page card.
    function countdown() {
      const ALL = 10000;
      const bar = document.createElement('i');
      bar.className = 'ht-slidein__timer'; bar.setAttribute('aria-hidden', 'true');
      el.appendChild(bar);
      let left = ALL, last = performance.now(), paused = false, raf = 0;
      const stop = () => { cancelAnimationFrame(raf); bar.remove(); };
      const tick = (now) => {
        if (el.classList.contains('is-expanded') || !el.classList.contains('is-open')) return stop();
        if (!paused) left -= now - last;
        last = now;
        bar.style.transform = `scaleX(${Math.max(0, left / ALL)})`;
        if (left > 0) { raf = requestAnimationFrame(tick); return; }
        stop();
        el.classList.remove('is-open');
        setTimeout(() => { el.hidden = true; }, 350);
        try {
          const n = Number(localStorage.getItem('ht-club-timeouts') || 0) + 1;
          localStorage.setItem('ht-club-timeouts', String(n));
          if (n >= 2) localStorage.setItem(CLUB_DISMISSED, String(Date.now() + 30 * 24 * 3600 * 1000));
        } catch (e) {}
      };
      ['pointerenter', 'touchstart', 'focusin'].forEach((ev) => el.addEventListener(ev, () => { paused = true; }, { passive: true }));
      el.addEventListener('pointerleave', () => { paused = false; });
      el.addEventListener('touchend', () => setTimeout(() => { paused = false; }, 1500), { passive: true });
      el.addEventListener('focusin', stop);
      raf = requestAnimationFrame(tick);
    }
    function onScroll() {
      const depth = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
      if (depth > 0.5) show();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (views >= 2) setTimeout(show, Math.max(0, earliest - Date.now()) + 50);
    else setTimeout(onScroll, Math.max(0, earliest - Date.now()) + 50);
  })();
  // Hero slider: crossfade product photos, the floating label follows the active slide.
  document.querySelectorAll('[data-ht-hero-slides]').forEach((box) => {
    const slides = [...box.querySelectorAll('.ht-hero__slide')];
    const label = box.parentElement.querySelector('[data-ht-hero-label]');
    if (slides.length < 2) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const wait = Math.max(3000, parseInt(box.dataset.interval, 10) || 5000);
    let i = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));
    slides.forEach((s) => { const img = s.querySelector('img'); if (img) img.loading = 'eager'; });
    // only the visible slide is a link for keyboard and screen readers
    const mark = () => slides.forEach((s, k) => {
      if (k === i) { s.removeAttribute('tabindex'); s.removeAttribute('aria-hidden'); }
      else { s.setAttribute('tabindex', '-1'); s.setAttribute('aria-hidden', 'true'); }
    });
    mark();
    let outT;
    function go(n) {
      // the new photo fades in on top of the old one, which stays fully visible underneath until the fade is done
      // (fading both at once let the background show through halfway)
      const prev = slides[i];
      slides.forEach((s) => s.classList.remove('was-active'));
      prev.classList.add('was-active');
      prev.classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      mark();
      clearTimeout(outT);
      outT = setTimeout(() => prev.classList.remove('was-active'), 950);
      if (!label) return;
      label.classList.add('is-swapping');
      setTimeout(() => {
        label.querySelector('span').textContent = slides[i].dataset.label || '';
        if (slides[i].getAttribute('href')) label.setAttribute('href', slides[i].getAttribute('href'));
        label.classList.remove('is-swapping');
      }, 350);
    }
    if (reduce) return;
    let timer = setInterval(() => go(i + 1), wait);
    document.addEventListener('visibilitychange', () => {
      clearInterval(timer);
      if (!document.hidden) timer = setInterval(() => go(i + 1), wait);
    });
  });

  // Inline page panel: loads a shop page into a box below its trigger, with a yellow "open full page"
  // button and a round close button. Same open/close motion both ways. Used by the footer quick links
  // and the size finder's guide button.
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const EASE = 'cubic-bezier(.2,.7,.2,1)';
  function slide(el, open, done, fromPx) {
    if (reduceMotion) { if (done) done(); return; }
    const from = fromPx != null ? fromPx : el.getBoundingClientRect().height;
    const to = open ? el.scrollHeight : 0;
    const pad = getComputedStyle(el).paddingTop;
    el.style.boxSizing = 'border-box';
    el.style.overflow = 'hidden';
    el.animate(
      [{ height: from + 'px', opacity: open && from === 0 ? 0 : 1, transform: open && from === 0 ? 'translateY(-6px)' : 'none',
         paddingTop: open && from === 0 ? '0px' : pad, paddingBottom: open && from === 0 ? '0px' : pad },
       { height: to + 'px', opacity: open ? 1 : 0, transform: open ? 'none' : 'translateY(-6px)',
         paddingTop: open ? pad : '0px', paddingBottom: open ? pad : '0px' }],
      { duration: 320, easing: EASE, fill: open ? 'none' : 'forwards' }
    ).onfinish = () => { el.style.overflow = ''; if (done) done(); };
  }
  // Page HTML for the inline panels, fetched once per page and shared: a hover/touch on a link starts it early.
  const pageCache = new Map();
  function getPage(path) {
    if (!pageCache.has(path)) {
      pageCache.set(path, fetch(path, { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.text() : Promise.reject(new Error(String(r.status)))))
        .catch((err) => { pageCache.delete(path); throw err; }));
    }
    return pageCache.get(path);
  }
  function inlinePanel(panel, opts = {}) {
    const S = cfg.strings || {};
    let key = null;
    const api = {
      get key() { return key; },
      close() {
        key = null;
        if (opts.onClose) opts.onClose();
        slide(panel, false, () => { if (!key) { panel.hidden = true; panel.innerHTML = ''; panel.getAnimations().forEach((a) => a.cancel()); } });
      },
      async open(url, k) {
        key = k;
        const wasHidden = panel.hidden;
        panel.hidden = false;
        panel.innerHTML = `<p class="ht-qlinks__loading">${esc(S.loading || '…')}</p>`;
        if (wasHidden) slide(panel, true, null, 0);
        const doc = new DOMParser().parseFromString(await getPage(url.pathname + url.search), 'text/html');
        const main = doc.querySelector('#MainContent');
        if (!main || key !== k) throw new Error('load');
        main.querySelectorAll('script:not([type="application/json"])').forEach((s) => s.remove());
        if (opts.strip) main.querySelectorAll(opts.strip).forEach((n) => n.remove());
        // a copy of another page inside this one: its title becomes an h2 (one h1 per page), no second "main"
        // landmark, and no ids that already exist here
        main.querySelectorAll('h1').forEach((h) => {
          const h2 = document.createElement('h2');
          [...h.attributes].forEach((a) => h2.setAttribute(a.name, a.value));
          h2.append(...h.childNodes);
          h.replaceWith(h2);
        });
        main.querySelectorAll('main, [role="main"]').forEach((n) => { n.removeAttribute('role'); if (n.tagName === 'MAIN') n.outerHTML = `<div>${n.innerHTML}</div>`; });
        main.querySelectorAll('[id]').forEach((n) => { if (document.getElementById(n.id)) n.removeAttribute('id'); });
        panel.innerHTML = '';
        const bar = document.createElement('div');
        bar.className = 'ht-qlinks__bar';
        bar.innerHTML = `<a class="ht-qlinks__full" href="${esc(url.href)}" target="_blank" rel="noopener">${esc(S.openFull || 'Open')}</a>`
          + `<button type="button" class="ht-qlinks__x" aria-label="${esc(S.close || 'Close')}"><span aria-hidden="true">✕</span></button>`;
        bar.querySelector('button').addEventListener('click', () => api.close());
        const body = document.createElement('div');
        body.className = 'ht-qlinks__body';
        body.append(...main.childNodes);
        const before = panel.getBoundingClientRect().height;
        panel.append(bar, body);
        body.querySelectorAll('[data-ht-fit]').forEach((el) => initFit(el));
        applyUnit(unit);
        if (!reduceMotion) panel.animate([{ height: before + 'px' }, { height: panel.scrollHeight + 'px' }], { duration: 320, easing: EASE });
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      },
    };
    return api;
  }
  const sameShopPage = (href) => {
    try { const u = new URL(href, location.href); return u.origin === location.origin && /\/pages\//.test(u.pathname) ? u : null; } catch (e) { return null; }
  };

  // Footer quick links: pills; shop pages open in the inline panel, anything else (customer account,
  // other sites) or a modified click behaves like a normal link.
  document.querySelectorAll('.footer-block--menu').forEach((block) => {
    const list = block.querySelector('ul');
    if (!list) return;
    block.classList.add('ht-qlinks');
    const panel = document.createElement('div');
    panel.className = 'ht-qlinks__panel';
    panel.hidden = true;
    list.after(panel);
    let current = null;
    const ip = inlinePanel(panel, { onClose: () => { if (current) current.removeAttribute('aria-current'); current = null; } });
    const warm = (e) => { const a = e.target.closest && e.target.closest('a'); const u = a && sameShopPage(a.href); if (u) getPage(u.pathname + u.search).catch(() => {}); };
    list.addEventListener('pointerenter', warm, true);
    list.addEventListener('touchstart', warm, { passive: true, capture: true });
    list.addEventListener('focusin', warm);
    list.addEventListener('click', async (e) => {
      const a = e.target.closest('a');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
      const url = sameShopPage(a.href);
      if (!url) return;
      e.preventDefault();
      if (current === a) { ip.close(); return; }
      if (current) current.removeAttribute('aria-current');
      current = a; a.setAttribute('aria-current', 'true');
      try { await ip.open(url, a.href); } catch (err) { if (current === a) window.location.href = a.href; }
    });
  });

  // Size finder: the yellow guide button opens the size guide page inside the finder
  // (without its own calculator, which would be a calculator inside the calculator).
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-ht-guide-toggle]');
    if (!btn) return;
    const dlg = btn.closest('dialog');
    const box = btn.closest('[data-ht-fit]') || (dlg && dlg.querySelector('[data-ht-fit]'));
    const panel = box && box.querySelector('[data-ht-guide-panel]');
    const url = sameShopPage(btn.dataset.href);
    if (!panel || !url) return;
    if (!panel.htPanel) panel.htPanel = inlinePanel(panel, { strip: '.ht-sizepage__open, .ht-sizepage__calc, .ht-sizepage__intro, .ht-sizepage__group, h1', onClose: () => btn.setAttribute('aria-expanded', 'false') });
    if (panel.htPanel.key) { panel.htPanel.close(); return; }
    btn.setAttribute('aria-expanded', 'true');
    try { await panel.htPanel.open(url, 'guide'); } catch (err) { window.location.href = url.href; }
  });

  // Size guide page: Sighthounds | Dachshund slider, and the calculator that expands in place.
  document.addEventListener('click', (e) => {
    const g = e.target.closest('[data-ht-page-group]');
    if (g) {
      const page = g.closest('.ht-sizepage');
      page.dataset.group = g.dataset.htPageGroup;
      page.querySelectorAll('[data-ht-page-group]').forEach((x) => x.setAttribute('aria-pressed', String(x === g)));
      return;
    }
    const x = e.target.closest('[data-ht-expand]');
    if (!x) return;
    const target = document.getElementById(x.getAttribute('aria-controls'));
    if (!target) return;
    const open = x.getAttribute('aria-expanded') !== 'true';
    x.setAttribute('aria-expanded', String(open));
    if (open) {
      target.hidden = false;
      target.querySelectorAll('[data-ht-fit]').forEach((el) => initFit(el));
      slide(target, true, null, 0);
    } else {
      slide(target, false, () => { if (x.getAttribute('aria-expanded') !== 'true') { target.hidden = true; target.getAnimations().forEach((a) => a.cancel()); } });
    }
  });

  // Collection pages: Összes | Agárfélék | Tacskó. Hides grid items of the other group and updates the count;
  // re-applied when the filters/sort re-render the grid.
  (function () {
    const bar = document.querySelector('[data-ht-coll-groups]');
    if (!bar) return;
    let group = 'all';
    try { group = sessionStorage.getItem('ht-coll-group') || 'all'; } catch (e) {}
    function apply() {
      bar.dataset.active = group;
      bar.querySelectorAll('[data-ht-coll-group]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.htCollGroup === group)));
      const items = document.querySelectorAll('#product-grid [data-ht-group]');
      let n = 0;
      items.forEach((li) => { const show = group === 'all' || li.dataset.htGroup === group; li.hidden = !show; if (show) n += 1; });
      document.querySelectorAll('.product-count__text').forEach((el) => {
        if (!el.dataset.htText) el.dataset.htText = el.textContent;
        // "7 termék" or, with filters on, "1/8 termék": show just the visible count in the group
        el.textContent = group === 'all' ? el.dataset.htText : el.dataset.htText.replace(/\d+(\s*\/\s*\d+)?/, String(n));
      });
    }
    bar.addEventListener('click', (e) => {
      const b = e.target.closest('[data-ht-coll-group]');
      if (!b) return;
      group = b.dataset.htCollGroup;
      try { sessionStorage.setItem('ht-coll-group', group); } catch (err) {}
      apply();
    });
    const grid = document.getElementById('ProductGridContainer');
    if (grid) new MutationObserver(() => { document.querySelectorAll('.product-count__text').forEach((el) => delete el.dataset.htText); apply(); }).observe(grid, { childList: true, subtree: true });
    apply();
  })();

  // One background scroll lock for every overlay (menu, cart, filter drawer, calculator window, zoomed guide):
  // the page (viewport) stops scrolling but keeps its position, and the sticky header stays where it is.
  (function () {
    const body = document.body;
    const html = document.documentElement;
    const wanted = () => /\boverflow-hidden(-mobile|-tablet|-desktop)?\b/.test(body.className)
      || !!document.querySelector('dialog[open], .ht-fit__diagram.is-zoomed')
      || (matchMedia('(max-width: 749px)').matches && !!document.querySelector('[data-ht-slidein].is-expanded.is-open'));   // the club form covers the phone screen
    let locked = false;
    function sync() {
      const want = wanted();
      if (want === locked) return;
      locked = want;
      html.classList.toggle('ht-scroll-lock', want);
    }
    new MutationObserver(sync).observe(body, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(sync).observe(html, { subtree: true, attributes: true, attributeFilter: ['open', 'class'] });
    document.addEventListener('close', sync, true);
  })();

  // ---------- Motion helpers (see the Motion block in ht.css) ----------
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Product page accordions: smooth height open / close instead of a snap.
  document.addEventListener('click', (e) => {
    const summary = e.target.closest('.product__accordion summary, .accordion summary');
    if (!summary || calm) return;
    const details = summary.parentElement;
    const content = summary.nextElementSibling;
    if (!content || details.dataset.mAnimating) return;
    e.preventDefault();
    details.dataset.mAnimating = '1';
    const done = () => { delete details.dataset.mAnimating; content.style.height = ''; };
    if (!details.open) {
      details.open = true;
      const h = content.scrollHeight;
      content.animate([{ height: '0px', opacity: 0 }, { height: `${h}px`, opacity: 1 }], { duration: 260, easing: 'cubic-bezier(.2,.8,.2,1)' }).onfinish = done;
    } else {
      const h = content.scrollHeight;
      content.animate([{ height: `${h}px`, opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 200, easing: 'cubic-bezier(.4,0,.2,1)' }).onfinish = () => { details.open = false; done(); };
    }
  });

  // Add to cart: short "added ✓" over the button that was pressed.
  let lastSubmit = null;
  document.addEventListener('click', (e) => { const b = e.target.closest('.product-form__submit'); if (b) lastSubmit = b; }, true);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
      if (!ev || ev.source !== 'product-form' || !lastSubmit) return;
      if (window.matchMedia('(max-width: 749px)').matches && document.querySelector('cart-drawer')) { lastSubmit = null; return; }
      const b = lastSubmit;
      lastSubmit = null;
      b.querySelectorAll('.m-added').forEach((x) => x.remove());
      const tag = document.createElement('span');
      tag.className = 'm-added';
      tag.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>${esc((cfg.strings || {}).added || '✓')}`;
      b.append(tag);
      setTimeout(() => tag.remove(), 1600);
    });
  }

  // Birthday Club: a few gold paws burst from the code when it appears.
  const pawSvg = '<svg viewBox="0 0 24 24" fill="currentColor"><ellipse cx="7" cy="8" rx="2.2" ry="3"/><ellipse cx="12" cy="6" rx="2.3" ry="3.2"/><ellipse cx="17" cy="8" rx="2.2" ry="3"/><path d="M12 11c-3.5 0-6.5 3.6-6.5 6.3 0 1.8 1.4 2.7 3 2.7 1.3 0 2.2-.6 3.5-.6s2.2.6 3.5.6c1.6 0 3-.9 3-2.7C18.5 14.6 15.5 11 12 11z"/></svg>';
  // htPawBurst(el, opts): paws burst from the centre of el (anything with getBoundingClientRect).
  // opts: { count, mix: true, z, size } -> mix = brand-colour mix: mostly gold, some mint, and navy (light mode) / cream (dark mode);
  // z = z-index (default 120, under the cart drawer); size = paw size in rem (default 2); dist = flight distance in px;
  // arc = [from, to] angles in radians (default the full circle; screen y points down, so [-PI, 0] is the upper half)
  window.htPawBurst = (el, opts = {}) => {
    if (calm || !el) return;
    const r = el.getBoundingClientRect();
    const n = opts.count || 10;
    const dark = document.documentElement.getAttribute('data-ht-mode') === 'dark';
    const mix = ['var(--ht-gold)', 'var(--ht-gold)', 'var(--ht-mint)', dark ? 'var(--ht-cream)' : 'var(--ht-ink)'];
    for (let i = 0; i < n; i += 1) {
      const p = document.createElement('span');
      p.className = 'm-paw';
      p.innerHTML = pawSvg;
      if (opts.mix) p.style.color = `rgb(${mix[i % mix.length]})`;
      if (opts.mix) { const s = 2.4 + Math.random() * 1.4; p.style.width = `${s}rem`; p.style.height = `${s}rem`; }
      if (opts.z) p.style.zIndex = opts.z;   // e.g. above the cart drawer
      if (opts.size) { p.style.width = `${opts.size}rem`; p.style.height = `${opts.size}rem`; }
      p.style.left = `${r.left + r.width / 2 - 10}px`;
      p.style.top = `${r.top + r.height / 2 - 10}px`;
      document.body.append(p);
      const a = opts.arc ? opts.arc[0] + ((opts.arc[1] - opts.arc[0]) * (i + Math.random() * 0.6)) / n : (Math.PI * 2 * i) / n + Math.random() * 0.5;
      const d = opts.dist ? opts.dist * (0.7 + Math.random() * 0.6) : (opts.mix ? 90 : 70) + Math.random() * (opts.mix ? 110 : 60);
      p.animate([
        { transform: 'translate(0,0) scale(.3) rotate(0deg)', opacity: 1 },
        { transform: `translate(${Math.cos(a) * d}px, ${Math.sin(a) * d - 20}px) scale(1) rotate(${(Math.random() - 0.5) * 120}deg)`, opacity: 1, offset: 0.7 },
        { transform: `translate(${Math.cos(a) * d * 1.15}px, ${Math.sin(a) * d + 10}px) scale(.8)`, opacity: 0 },
      ], { duration: 900, easing: 'cubic-bezier(.2,.8,.2,1)' }).onfinish = () => p.remove();
    }
  };

  // Add to cart: a gold paw flies from the pressed button to the header bag, the bag tilts when it lands and the count
  // bump (hx.js) follows. Works for the product form and Complete the look ("add all": one paw per piece, max 3).
  // While a paw is in the air the cart drawer waits for the landing (it would cover the bag); the cart request is
  // usually slower than the ~0.7 s flight anyway. A failed add drops the paw. Nothing flies with reduce motion.
  const FLY_MS = 680;
  let flying = [];
  window.htFlyUntil = 0;            // read by hx.js: the count waits for the landing too
  function gateDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.htGated || typeof drawer.open !== 'function') return;
    drawer.htGated = true;
    const open = drawer.open;
    drawer.open = function (...args) {
      const wait = window.htFlyUntil - performance.now();
      if (wait > 0) setTimeout(() => open.apply(this, args), wait); else open.apply(this, args);
    };
  }
  function tiltBag(bag) {
    const icon = bag.querySelector('svg');
    if (!icon) return;
    icon.animate([
      { transform: 'none' }, { transform: 'scale(1.14) rotate(-13deg)', offset: 0.25 }, { transform: 'rotate(9deg)', offset: 0.55 },
      { transform: 'rotate(-4deg)', offset: 0.8 }, { transform: 'none' },
    ], { duration: 560, easing: 'ease-out' });
  }
  function flyToBag(from, n = 1) {
    const hx = document.querySelector('[data-hx]');
    const bag = hx && hx.querySelector('[data-hx-cart]');
    if (calm || !from || !bag || !bag.getClientRects().length) return;
    gateDrawer();
    // the header may have slid away while scrolling down: bring it back and aim at where its bag will be
    const ty = (() => { const m = getComputedStyle(hx).transform; return m && m !== 'none' ? new DOMMatrixReadOnly(m).m42 : 0; })();
    hx.classList.remove('is-hidden');
    const b = bag.getBoundingClientRect();
    const x1 = b.left + b.width / 2, y1 = b.top + b.height / 2 - Math.min(0, ty);
    const s0 = from.getBoundingClientRect();
    const count = Math.min(Math.max(1, n), 3);
    const tail = (count - 1) * 90 + 140;           // last paw's delay + a beat for the tilt
    window.htFlyUntil = performance.now() + FLY_MS + tail + 100;   // provisional; set exactly once the flight has started
    for (let i = 0; i < count; i += 1) {
      const x0 = s0.left + s0.width / 2 + (i - (count - 1) / 2) * 26, y0 = s0.top + s0.height / 2;
      const cx = x0 + (x1 - x0) * 0.3, cy = Math.min(y0, y1) - Math.max(60, Math.abs(y0 - y1) * 0.25);   // arc control point
      const frames = [];
      for (let k = 0; k <= 16; k += 1) {
        const t = k / 16, e = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;   // ease in-out along the arc
        const x = (1 - e) * (1 - e) * x0 + 2 * (1 - e) * e * cx + e * e * x1;
        const y = (1 - e) * (1 - e) * y0 + 2 * (1 - e) * e * cy + e * e * y1;
        frames.push({ transform: `translate(${(x - 14).toFixed(1)}px, ${(y - 14).toFixed(1)}px) scale(${(1.1 - 0.55 * e).toFixed(3)}) rotate(${Math.round(-28 + 46 * e)}deg)`, opacity: t > 0.9 ? (1 - t) * 10 : 1 });
      }
      const p = document.createElement('span');
      p.className = 'm-paw m-fly';
      p.setAttribute('aria-hidden', 'true');
      p.innerHTML = pawSvg;
      document.body.append(p);
      const a = p.animate(frames, { duration: FLY_MS, delay: i * 90, easing: 'linear', fill: 'backwards' });
      if (i === 0) a.ready.then(() => { if (flying.length) window.htFlyUntil = performance.now() + FLY_MS + tail; });
      flying.push(p);
      a.onfinish = () => { p.remove(); flying = flying.filter((x) => x !== p); if (i === 0) tiltBag(bag); };
    }
  }
  function cancelFly() {
    window.htFlyUntil = 0;
    flying.forEach((p) => { p.getAnimations().forEach((a) => a.cancel()); p.remove(); });
    flying = [];
  }
  window.htFlyToBag = flyToBag;
  window.htFlyCancel = cancelFly;
  document.addEventListener('click', (e) => {
    const b = e.target.closest('product-form .product-form__submit');
    if (b && !b.disabled && b.getAttribute('aria-disabled') !== 'true') flyToBag(b);
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartError, cancelFly);

  // Free-delivery bar (drawer + cart page): Dawn rebuilds it on every cart change, so the fill grows from the last value
  // the shopper saw (sessionStorage) once the bar is on screen (the drawer bar only when the drawer slides in). When it
  // reaches 100 % a gold shimmer runs along it and a few paws pop at its end.
  const SHIP_KEY = 'ht-ship-seen';
  const shipGet = () => { try { return Number(sessionStorage.getItem(SHIP_KEY) || 0); } catch (e) { return 0; } };
  const shipSet = (v) => { try { sessionStorage.setItem(SHIP_KEY, String(v)); } catch (e) {} };
  const shipTo = (bar) => Math.min(100, parseFloat(bar.style.getPropertyValue('--ht-ship')) || 0);
  function holdShip(bar) {
    // until it plays, a new bar shows the last value the shopper saw (not its new value, which would jump back)
    const fill = bar.querySelector('.ht-ship__fill');
    if (calm || !fill) return;
    fill.style.transition = 'none';
    fill.style.width = `${shipGet()}%`;
  }
  function playShip(bar) {
    const fill = bar.querySelector('.ht-ship__fill');
    const to = shipTo(bar);
    const from = shipGet();
    shipSet(to);
    if (calm || !fill) return;
    fill.style.width = `${to}%`;
    if (Math.abs(to - from) < 0.5) return;
    const a = fill.animate([{ width: `${from}%` }, { width: `${to}%` }], { duration: 650 + Math.abs(to - from) * 4, easing: 'cubic-bezier(.2,.7,.2,1)' });
    if (to < 100 || from >= 100) return;
    a.onfinish = () => {
      bar.classList.add('is-unlocked');
      const track = bar.querySelector('.ht-ship__track');
      // from the end of the bar, upwards, kept far enough from the screen edge that no paw flies off it
      const end = { getBoundingClientRect: () => { const r = track.getBoundingClientRect(); return { left: Math.min(r.right - 8, document.documentElement.clientWidth - 80), top: r.top - 6, width: 12, height: 12 }; } };
      window.htPawBurst(end, { count: 6, z: 1200, size: 1.6, dist: 50, arc: [-Math.PI * 0.95, -Math.PI * 0.05] });
    };
  }
  const shipIO = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => entries.forEach((en) => {
    if (!en.isIntersecting) return;
    shipIO.unobserve(en.target);
    playShip(en.target);
  }), { threshold: 0.5 }) : null;   // half: the drawer's scroll box clips the top of the bar a little
  let shipRaf = 0;
  function scanShip() {
    shipRaf = 0;
    const bars = document.querySelectorAll('.ht-ship:not([data-ht-ship])');
    bars.forEach((bar) => { bar.dataset.htShip = '1'; if (shipIO) { holdShip(bar); shipIO.observe(bar); } else playShip(bar); });
    // emptied cart: the next first item starts the bar from zero again
    if (!document.querySelector('.ht-ship') && document.querySelector('cart-drawer.is-empty, cart-items.is-empty')) shipSet(0);
  }
  ['cart-drawer', '#main-cart-items'].forEach((sel) => {
    const el = document.querySelector(sel);
    if (el) new MutationObserver(() => { if (!shipRaf) shipRaf = requestAnimationFrame(scanShip); }).observe(el, { childList: true, subtree: true });
  });
  scanShip();

  // Cart drawer: after a quantity change, the changed line's quantity and price give a short pulse.
  // (Shopify rebuilds the drawer HTML first, then announces the change, so this only decorates the new HTML.)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
      if (!ev || ev.source !== 'cart-items' || !ev.variantId || calm) return;
      requestAnimationFrame(() => {
        const input = document.querySelector(`cart-drawer-items [data-quantity-variant-id="${ev.variantId}"], cart-items [data-quantity-variant-id="${ev.variantId}"]`);
        const row = input && input.closest('.cart-item');
        if (!row) return;
        row.querySelectorAll('.quantity__input, .cart-item__price-wrapper, .cart-item__totals .price').forEach((el) => {
          el.classList.remove('m-pulse'); void el.offsetWidth; el.classList.add('m-pulse');
        });
      });
    });
  }

  // Product "Méretek" accordion: its button opens the same calculator window as "Melyik méret jó?"
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-ht-sizeacc-open]')) return;
    const opener = document.querySelector('[data-ht-fit-open]');
    if (opener) opener.click();
  });

  // Breed tabs: a pill slides to the selected tab (like the cm/inch and group sliders).
  document.querySelectorAll('[data-ht-tabbar]').forEach((bar) => {
    const pill = document.createElement('span');
    pill.className = 'ht-tabs__pill';
    pill.setAttribute('aria-hidden', 'true');
    bar.prepend(pill);
    const place = (instant) => {
      const sel = bar.querySelector('[aria-selected="true"]');
      if (!sel) return;
      if (instant) pill.style.transition = 'none';
      pill.style.width = `${sel.offsetWidth}px`;
      pill.style.height = `${sel.offsetHeight}px`;
      pill.style.transform = `translate(${sel.offsetLeft}px, ${sel.offsetTop}px)`;
      if (instant) { pill.getBoundingClientRect(); pill.style.transition = ''; }
    };
    bar.classList.add('has-pill');
    place(true);
    new MutationObserver(() => place(false)).observe(bar, { subtree: true, attributes: true, attributeFilter: ['aria-selected'] });
    window.addEventListener('resize', () => place(true));
  });

  // "You may also like" keeps its reserved height (ht.css) until Dawn's fetch is done, and gives it back only if that
  // came back empty. Dawn fetches it only when it comes within 400 px of the screen, so a timer from page load would
  // shrink it first and make the footer jump when the products arrive. The fetch carries this section's id; its
  // resource-timing entry says the response is in (Dawn fills the block a moment later, then it counts as loaded).
  // The fetch also starts earlier (2000 px ahead instead of Dawn's 400 px), so filling or releasing the block happens
  // off screen even when the visitor scrolls fast.
  document.querySelectorAll('product-recommendations.related-products').forEach((el) => {
    const release = () => { if (!el.classList.contains('product-recommendations--loaded')) el.style.minHeight = '0'; };
    if (typeof el.loadRecommendations === 'function') {
      const load = el.loadRecommendations;
      el.loadRecommendations = function (id) { if (this.htRequested) return; this.htRequested = true; load.call(this, id); };   // once
      new IntersectionObserver((en, io) => {
        if (!en[0].isIntersecting) return;
        io.disconnect();
        if (el.observer) el.observer.unobserve(el);   // Dawn's own 400 px trigger is not needed any more
        el.loadRecommendations(el.dataset.productId);
      }, { rootMargin: '0px 0px 2000px 0px' }).observe(el);
    }
    new MutationObserver(() => setTimeout(release, 50)).observe(el, { childList: true });
    const mine = (e) => e.name.includes('/recommendations/products') && e.name.includes(`section_id=${el.dataset.sectionId}`);
    try {
      const po = new PerformanceObserver((list) => { if (list.getEntries().some(mine)) { po.disconnect(); setTimeout(release, 400); } });
      po.observe({ type: 'resource', buffered: true });
    } catch (e) {
      // no resource timing: same 400 px trigger as Dawn, then a generous wait for the response
      new IntersectionObserver((en, io) => { if (en[0].isIntersecting) { io.disconnect(); setTimeout(release, 5000); } }, { rootMargin: '0px 0px 400px 0px' }).observe(el);
    }
  });

  // ---------- Invitation link (?club_invite=TOKEN from the email): open the club card, dogs only ----------
  function leaveInvite(form) {
    delete form.dataset.invite;
    const box = form.closest('[data-ht-club]');
    box.classList.remove('is-invite');
    box.querySelectorAll('[data-ht-invite-orig]').forEach((el) => { el.textContent = el.dataset.htInviteOrig; el.removeAttribute('data-ht-invite-orig'); });
    form.querySelectorAll('[data-ht-invite-hide]').forEach((el) => { el.hidden = false; el.removeAttribute('data-ht-invite-hide'); });
    const langPick = form.querySelector('[data-ht-invite-lang]'); if (langPick) langPick.hidden = true;
  }
  (function clubInvite() {
    const params = new URLSearchParams(location.search);
    const token = params.get('club_invite');
    if (!token) return;
    params.delete('club_invite');
    history.replaceState(null, '', `${location.pathname}${params.toString() ? `?${params}` : ''}${location.hash}`);
    const slide = document.querySelector('[data-ht-slidein]');
    const box = (slide && slide.querySelector('[data-ht-club]')) || document.querySelector('#birthday-club [data-ht-club]');
    if (!box) return;
    const card = box.closest('[data-ht-clubcard]'); if (card) card.classList.remove('is-collapsed');
    const form = box.querySelector('[data-ht-club-form]');
    form.dataset.invite = token;
    box.classList.add('is-invite');
    [form.querySelector('[name="email"]').closest('label'), form.querySelector('.ht-club__consent')].forEach((el) => {
      if (el) { el.hidden = true; el.setAttribute('data-ht-invite-hide', ''); }
    });
    const langPick = form.querySelector('[data-ht-invite-lang]'); if (langPick) langPick.hidden = false;   // which language we write in
    const title = box.querySelector('.ht-club__title');
    const text = box.querySelector('.ht-club__text');
    [[title, club.inviteTitle], [text, club.inviteText]].forEach(([el, s]) => {
      if (el && s) { el.dataset.htInviteOrig = el.textContent; el.textContent = s; }
    });
    const focusName = () => { const n = form.querySelector('[name="dog_name"]'); if (n) n.focus({ preventScroll: true }); };
    if (slide) {
      slide.dataset.invite = '1';
      slide.hidden = false;
      slide.classList.add('is-expanded');
      requestAnimationFrame(() => slide.classList.add('is-open'));
      setTimeout(focusName, 500);
    } else {
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(focusName, 700);
    }
  })();

  // Instagram feed strip: slow endless drift (two copies of the tiles, wraps at the half), pauses on hover / touch / focus,
  // swipe on phones, drag with the mouse on desktop. Nothing moves off-screen, in a background tab or with "reduce motion".
  document.querySelectorAll('[data-ht-insta]').forEach((strip) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const SPEED = 26;                                  // px per second
    let pos = 0, last = 0, paused = false, visible = false, resumeT = 0;
    const half = () => strip.scrollWidth / 2;
    const wrap = () => { const h = half(); if (h > 0 && strip.scrollLeft >= h) strip.scrollLeft -= h; };
    const pause = () => { paused = true; clearTimeout(resumeT); };
    let lastScroll = 0;
    const resume = (ms) => {
      clearTimeout(resumeT);
      resumeT = setTimeout(function go() {
        if (dragging) return;
        if (performance.now() - lastScroll < 300) { resumeT = setTimeout(go, 300); return; }   // fling still coasting
        settle(); pos = strip.scrollLeft; paused = false;
      }, ms);
    };
    const step = (now) => {
      const dt = last ? Math.min(0.05, (now - last) / 1000) : 0; last = now;
      if (visible && !paused && !document.hidden) {
        pos += SPEED * dt;
        const h = half(); if (h > 0 && pos >= h) pos -= h;
        strip.scrollLeft = pos;                        // float position kept here; scrollLeft may round
      }
      requestAnimationFrame(step);
    };
    new IntersectionObserver((e) => {
      visible = e[0].isIntersecting;
      // load all photos once the feed is near, so a fast fling never reaches an empty tile
      if (visible) strip.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
    }, { rootMargin: '300px' }).observe(strip);
    strip.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') pause(); });
    strip.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse' && !dragging) resume(500); });
    strip.addEventListener('touchstart', pause, { passive: true });
    strip.addEventListener('touchend', () => resume(2500), { passive: true });
    strip.addEventListener('wheel', () => { pause(); resume(2500); }, { passive: true });
    strip.addEventListener('focusin', pause);
    strip.addEventListener('focusout', () => resume(800));
    // The endless-loop jump (back by half) only happens once the strip has come to rest: jumping during a fling
    // fights the phone's momentum scroll (springy bounce + "ghost" doubled tiles).
    let idleT = 0;
    const settle = () => { const h = half(); if (h <= 0) return;
      if (strip.scrollLeft >= h + 2) strip.scrollLeft -= h; else if (strip.scrollLeft < 2) strip.scrollLeft += h; };   // +2: landing exactly on h must not jump back to 0 (ping-pong)
    // Easter egg: a really fast spin (faster than a normal swipe) throws a burst of brand-coloured paws. Max once per 1.5 s.
    let spinX = 0, spinT = 0, lastBurst = 0;
    const spinCheck = () => {
      const now = performance.now(), x = strip.scrollLeft, dt = now - spinT, dx = Math.abs(x - spinX);
      if (dt > 0 && dt < 120 && dx < half() / 2 && dx / dt > 4 && now - lastBurst > 1500) {   // > 4000 px/s, ignores loop jumps
        lastBurst = now;
        window.htPawBurst && window.htPawBurst(strip, { count: 18, mix: true });
      }
      spinX = x; spinT = now;
    };
    strip.addEventListener('scroll', () => { if (!paused) return; lastScroll = performance.now(); spinCheck(); clearTimeout(idleT); idleT = setTimeout(settle, 220); }, { passive: true });
    if ('onscrollend' in strip) strip.addEventListener('scrollend', () => { if (paused) { clearTimeout(idleT); settle(); } });
    // mouse drag (desktop); a drag never counts as a click on a tile
    let dragging = false, startX = 0, startLeft = 0, moved = 0;
    strip.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button) return;
      dragging = true; moved = 0; startX = e.clientX; startLeft = strip.scrollLeft; pause();
    });
    window.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      moved = Math.max(moved, Math.abs(e.clientX - startX));
      strip.scrollLeft = startLeft - (e.clientX - startX);
    });
    window.addEventListener('pointerup', () => { if (dragging) { dragging = false; resume(1500); } });
    strip.addEventListener('click', (e) => { if (moved > 6) { e.preventDefault(); moved = 0; } }, true);
    strip.addEventListener('dragstart', (e) => e.preventDefault());
    requestAnimationFrame(step);
  });

  // Birthday Club section on the home page: compact card until opened (button, #birthday-club arrival, tile/menu link)
  document.querySelectorAll('[data-ht-clubcard]').forEach((card) => {
    const open = (focus) => {
      if (!card.classList.contains('is-collapsed')) return;
      const from = card.offsetHeight;
      card.classList.remove('is-collapsed');
      // grow smoothly from the compact height to the full form (text + form fade in on top, see ht.css)
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const to = card.offsetHeight;
        card.style.overflow = 'hidden';
        card.animate([{ height: `${from}px` }, { height: `${to}px` }], { duration: 520, easing: 'cubic-bezier(.2,.8,.2,1)' })
          .onfinish = () => { card.style.overflow = ''; };
      }
      const f = card.querySelector('[name="email"]');
      if (focus && f) setTimeout(() => f.focus({ preventScroll: true }), 420);
    };
    card.querySelector('[data-ht-clubsec-join]').addEventListener('click', () => open(true));
    if (location.hash === '#birthday-club') open(false);
    window.addEventListener('hashchange', () => { if (location.hash === '#birthday-club') open(false); });
    document.addEventListener('click', (e) => { if (e.target.closest('a[href*="#birthday-club"]')) open(false); }, true);
  });

})();
